import React from 'react';
import { Growl } from 'primereact/growl';
import { Button } from 'primereact/button';
import {Lightbox} from 'primereact/lightbox';
import servicioArchivo from '../servicios/ServicioArchivos';
import servicioEnvioCorreo from '../servicios/ServicioEnvioCorreo';

export class AltaImss extends React.Component {

  constructor() {
    super();
    this.state = {
      iFrameSrc:null

    }
  }

  descargaAltaImss=()=>{
        servicioArchivo.descargaArchivo('/afil/descarga.json')
        .then((response) => {
            if (response !== "si")
                return this.growl.show({ severity: 'error', summary: '', detail: response });
        });   
  }

  enviaPorCorreo=()=>{
    servicioEnvioCorreo.enviaAfilPorCorreo().then((response)=>{
        this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
      }).catch((error)=>{})
  }

  visorPdf = () => {
    servicioArchivo.descargaArchivoComoBlob('/afil/descarga.json')
        .then((response) => {
            this.setState({iFrameSrc:URL.createObjectURL(response)});
            document.getElementById("btnVisorPdfTarget").click();
    }).catch((error) => {
        this.growl.show({ severity: 'error', summary: '', detail: error });
    });
    
}

  render() {
    let {iFrameSrc } = this.state;

    const visorPdfTarget = (
      <button id="btnVisorPdfTarget" className="p-link" style={{visibility:"hidden"}}></button>
  );

    return (
      <div>
        <div className="content-section implementation">
          <Growl ref={(el) => this.growl = el} />

          <Lightbox target={visorPdfTarget}>
                    <div id="contenedorIframe"  >
                        <iframe id="elIframe" src={iFrameSrc} frameBorder="0" className="iframeEstilo" ></iframe>
                    </div>
                </Lightbox>

          <div className="card card-w-title">
            <h1>Alta IMSS</h1>
            <div className="p-grid p-fluid">
              <div className="p-col-12 p-md-4">
                <Button type="button" label="Descarga Alta IMSS" icon="pi-md-cloud-download" className="deep-orange-btn" onClick={this.descargaAltaImss}></Button>

              </div>
              <div className="p-col-12 p-md-4">
                <Button type="button" label="Ver Alta IMSS" icon="pi-md-remove-red-eye" className="indigo-btn flat-btn" onClick={this.visorPdf}></Button>
              </div>

              <div className="p-col-12 p-md-4">
                <Button type="button" label="Enviar a mi correo" icon="pi-md-mail" className="teal-btn flat-btn" onClick={this.enviaPorCorreo}></Button>
              </div>

            </div>
          </div>


        </div>



      </div>

    );
  }

}